import "@/index.css";


import * as Sentry from "@sentry/react";
import * as ReactDOM from "react-dom/client";

import { createRouter, RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { PostHogProvider } from "@posthog/react";

import { routeTree } from "@/routes.gen";
import { queryClient } from "@/lib/query";
import { mSentryPublicDSN } from "@/config/sentry";
import { posthog } from "@/posthog";


const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
});

Sentry.init({
  dsn: mSentryPublicDSN,
  sendDefaultPii: true,
  integrations: [
    Sentry.tanstackRouterBrowserTracingIntegration(router),
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration({
      colorScheme: "system",
      autoInject: false,
      useSentryUser: {
        name: "fullName",
        email: "email",
      },
    }),
  ],
  enableLogs: true,
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const element = document.getElementById("root") as HTMLElement;

const root = ReactDOM.createRoot(element, {
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
  onUncaughtError: Sentry.reactErrorHandler((error, info) => console.warn("Uncaught Error", error, info.componentStack)),
});

root.render(
  <PostHogProvider client={posthog}>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </PostHogProvider>
);

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
